const KEY = process.env.VUE_APP_ID ? process.env.VUE_APP_ID + '-lang' : 'lang'
import dayjs from 'dayjs'
import numeral from 'numeral'

numeral.register('locale', 'num-en', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  currency: {
    symbol: '€'
}
})

numeral.register('locale', 'num-ca', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  currency: {
    symbol: '€'
}
})

numeral.register('locale', 'num-es', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  currency: {
    symbol: '€'
}
})

export default {
  state: {
    lang: localStorage.getItem(KEY) || 'ca',
  },
  mutations: {
    setLanguage(state, lang) {
      state.lang = lang
      dayjs.locale(lang)
      numeral.locale('num-' + lang)
    },
  },
  actions: {
    setLanguage(context, lang) {
      localStorage.setItem(KEY, lang)
      //context.dispatch('clearCache')
      context.commit('setLanguage', lang)
    },
  },
}
